import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataView } from "primereact/dataview";
import { formatDate, formatDateNewWithTime } from "../../../constants/DateUtil/DateUtil";
import { Accordion, AccordionTab } from "primereact/accordion";
import SuccessModal from "../../SuccessModal";
import PickupRequest from "../../PickupAndDeliveryModal/PickupRequest";
import DeliveryRequest from "../../PickupAndDeliveryModal/DeliveryRequest";
import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";

const { innerWidth: width, innerHeight: height } = window;


const AdminJobRequestsListView = ({ orderInfoData, JobType, callRequestApi, pickupType }) => {


  const [modalVisible, setModalVisible] = useState(false);

  const [collectPaymentResponse, setCollectPaymentResponse] = useState(null);

  useEffect(() => {
    if (collectPaymentResponse !== null) {
      callRequestApi();
      setModalVisible(true);
      setCollectPaymentResponse(null);
    }
  }, [collectPaymentResponse]);



  const RenderTabView = () => {
    if (!orderInfoData || orderInfoData.length === 0) return null;

    const tableData = orderInfoData.map((item) => {
      if (JobType === "pickup") {
        return {
          formattedPickupDeliveryDate: formatDate(item?.pickupOn),
          pickupDeliveryOn: item?.pickupOn,
          customerName: item?.customerName,
          customerMobile: item?.customerMobile,
          customerAddress: item?.customerAddress,
          pickupDeliveryTimeSlot: item?.pickupTimeSlot,
          riderFirstName: item?.rider?.firstName,
          riderLastName: item?.rider?.lastName,
          pickupDeliveryStatus: item?.pickupStatus,
          pickupDeliveryOrderStatus: "",
          pickupDeliveryRequestId: item?.id,
          storeCustomerId: item?.storeCustomerId,
          createdDateWithTime: formatDateNewWithTime(item.createdDate),
          source: item.source,
          customerType: item.customerType,
          orderId: null,
          orderNo: null,
          invoiceNo: null,
          createdDate: null,
          remarks: item?.remarks,
        };
      } else {
        return {
          formattedPickupDeliveryDate: formatDate(item?.deliveryOn),
          pickupDeliveryOn: item?.deliveryOn,
          customerName: item?.order?.customerName,
          customerMobile: item?.order?.customerMobile,
          customerAddress: item?.order?.customerAddress,
          pickupDeliveryTimeSlot: item?.deliveryTimeSlot,
          riderFirstName: item?.rider?.firstName,
          riderLastName: item?.rider?.lastName,
          pickupDeliveryStatus: item?.deliveryStatus,
          pickupDeliveryOrderStatus: item?.order?.status,
          pickupDeliveryRequestId: item?.id,
          storeCustomerId: item?.order?.storeCustomerId,
          createdDateWithTime: formatDateNewWithTime(item.createdDate),
          orderId: item?.order?.id,
          orderNo: item?.order?.orderNo,
          invoiceNo: item?.order?.invoiceNo,
          createdDate: formatDate(item?.createdDate),
          remarks: null,
        };
      }
    });

    const BodyTemplateMobile = (rowData) => {
      return (
        <div  >

          <span >
            {rowData?.customerMobile}
          </span>

        </div>
      )
    }


    return (
      <DataTable
        value={tableData}
        paginator
        rows={10}
        tableStyle={{ minWidth: '120rem' }}
        rowsPerPageOptions={[10, 25, 50]}
        stripedRows
        showGridlines
        responsiveLayout="scroll"
        scrollable
        scrollHeight={height - 150}
      >

        <Column
          header="S No."
          style={{ width: "70px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>


        {(pickupType === "ORDER_BOOKED") && (
          <Column field="invoiceNo" style={{
            width: "90px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }} header="Invoice No" />
        )}

        {JobType === "delivery" && (
          <Column field="invoiceNo" style={{
            width: "90px",
            paddingVertical: 1,
            paddingLeft: 5,
            paddingRight: 1,
          }} header="Invoice No" />
        )}
        {pickupType === "ORDER_BOOKED" && (<Column field="formattedPickupDeliveryCompleteOnDate" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Done On" />)}
        <Column field="createdDateWithTime" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Created At" />
        <Column field="rider" header="Rider" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} body={(rowData) => rowData?.riderFirstName + " " + rowData?.riderLastName} />
        <Column field="customerName" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Customer" />
        <Column field="customerMobile" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Mobile" body={BodyTemplateMobile} />
        <Column field="customerAddress" style={{
          width: "140px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Address" />

        <Column field="formattedPickupDeliveryDate" style={{
          width: "120px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Reschedule Date" />
        <Column field="pickupDeliveryTimeSlot" style={{
          width: "90px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Time Slot" />

        <Column field="status" header="Status" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} body={(rowData) => rowData?.pickupDeliveryStatus.replace(/_/g, " ")} />

        {JobType === "pickup" && (<Column field="source" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Source" />
        )}
        {JobType === "pickup" && (<Column field="customerType" style={{
          width: "110px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Customer Type" />
        )}
        <Column field="remarks" style={{
          width: "150px",
          paddingVertical: 1,
          paddingLeft: 5,
          paddingRight: 1,
        }} header="Remarks" />
      </DataTable>
    );
  };

  return (
    <div className="mx-4 my-2">
      <div className="mx-4 report-table">
        <div className="tab-view-table">{RenderTabView()}</div>
      </div>
    </div>
  );
};

export default AdminJobRequestsListView;
